import QueryString from "qs"
import http from "../index"
import {
  apiGetListSettingPrice,
  apiImportSimPoolData,
  apiGetListReceiptPoolData,
  apiCreateReceiptPoolData,
  apiGetReceiptPoolDataDetail,
  apiUpdateReceiptPoolData,
  apiBrowseReceiptPoolData,
  apiRefuseReceiptPoolData,
  apiGetPhoneParentsList,
  apiCreateSettingPrice,
  apiUpdateSettingPrice,
  apiBrowseOrderPoolData,
  apiRefuseOrderPoolData,
  apiSyncSimOrder,
  apiSyncSimReceipt,
  apiExportListSim,
  apiGetListDataReceiptPoolData,
  apiUpdateDataReceiptPoolData,
  apiGetDetailDataReceiptPoolData,
  apiBrowseDataReceiptPoolData,
  apiRefuseDataReceiptPoolData,
  apiCreateDataReceiptPoolData,
  apiGetAllPackageCode,
  apiImportTemplateSimPoolData,
  apiRenewDataReceiptPoolData,
  apiGetListAllReceipt,
} from "./urls"

const getGetListSettingPrice = params => http.get(apiGetListSettingPrice, { params: params })
const importSimPoolData = body => http.post(apiImportSimPoolData, body)
const getTemplateSimPoolData = (params) => http.get(apiImportTemplateSimPoolData, { responseType: "blob", params: params },)
const getGetListReceiptPoolData = params => http.get(apiGetListReceiptPoolData, { params: params })
const createReceiptPoolData = body => http.post(apiCreateReceiptPoolData, body)
const getReceiptPoolDataDetail = id => http.get(apiGetReceiptPoolDataDetail(id))
const updateReceiptPoolData = (id, body) => http.put(apiUpdateReceiptPoolData(id), body)
const browseReceiptPoolData = id => http.put(apiBrowseReceiptPoolData(id))
const refuseReceiptPoolData = (id, body) => http.put(apiRefuseReceiptPoolData(id), body)
const getPhoneParentsList = (params) => http.get(apiGetPhoneParentsList, { params: params })
const createSettingPrice = (body) => http.post(apiCreateSettingPrice, body)
const updateSettingPrice = (id, body) => http.put(apiUpdateSettingPrice(id), body)
const browseOrderPoolData = id => http.put(apiBrowseOrderPoolData(id))
const refuseOrderPoolData = (id, body) => http.put(apiRefuseOrderPoolData(id), body)
const syncSimOrder = id => http.put(apiSyncSimOrder(id))
const syncSimReceipt = id => http.put(apiSyncSimReceipt(id))
const exportListSim = (params) => http.get(apiExportListSim, { responseType: "blob", params: params },)
const getGetListDataReceiptPoolData = params => http.get(apiGetListDataReceiptPoolData, { params: params })
const createDataReceiptPoolData = (body) => http.post(apiCreateDataReceiptPoolData, body)
const updateDataReceiptPoolData = (id, body) => http.put(apiUpdateDataReceiptPoolData(id), body)
const getDetailDataReceiptPoolData = id => http.get(apiGetDetailDataReceiptPoolData(id))
const browseDataReceiptPoolData = id => http.put(apiBrowseDataReceiptPoolData(id))
const refuseDataReceiptPoolData = (id, body) => http.put(apiRefuseDataReceiptPoolData(id), body)
const getAllPackageCode = params => http.get(apiGetAllPackageCode, { params: params })
const renewDataReceiptPoolData = (id, body) => http.post(apiRenewDataReceiptPoolData(id), body)
const getListAllReceipt = params => http.get(apiGetListAllReceipt, { params: params })

const PoolDataService = {
  getGetListSettingPrice,
  importSimPoolData,
  getGetListReceiptPoolData,
  createReceiptPoolData,
  getReceiptPoolDataDetail,
  updateReceiptPoolData,
  browseReceiptPoolData,
  refuseReceiptPoolData,
  getPhoneParentsList,
  createSettingPrice,
  updateSettingPrice,
  browseOrderPoolData,
  refuseOrderPoolData,
  syncSimOrder,
  syncSimReceipt,
  exportListSim,
  getGetListDataReceiptPoolData,
  updateDataReceiptPoolData,
  getDetailDataReceiptPoolData,
  browseDataReceiptPoolData,
  refuseDataReceiptPoolData,
  createDataReceiptPoolData,
  getAllPackageCode,
  getTemplateSimPoolData,
  renewDataReceiptPoolData,
  getListAllReceipt
}
export default PoolDataService
